import ActPayments from "../../../UIElements/ActPayments";
import CommonToolbar from "../../../UIElements/CommonToolbar";
import DocumentArchiveTable from "../../../UIElements/DocumentArchiveTable";
import EnumsContext from "../../../../context/enums-context";
import { convertSumWithLatestCurrencyRate, formatCurrency, formatQuantityWithMeasurement, formatShortDate, useEnumLabel } from "../../../../Utils/Utils";
import HistoryElement from "../../../UIElements/HistoryElement";
import useApi from "../../../../Utils/BackendClient";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { useFormik } from "formik";
import useGetEnums from "../../../../Utils/EnumsUtils";
import { useLocation, useNavigate } from "react-router-dom";
import { useIsMobile } from "../../../../Utils/ResizeUtils";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { FloatLabel } from "primereact/floatlabel";
import { InputText } from "primereact/inputtext";
import { TabMenu } from "primereact/tabmenu";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { Sidebar } from "primereact/sidebar";

import commonStyle from "../../CommonStyles.module.css"
import DropdownInput from "../../../UIElements/Inputs/DropdownInput";
import CalendarInput from "../../../UIElements/Inputs/CalendarInput";
import ActNumberWithAutogenerateInput from "../../../UIElements/Inputs/ActNumberWithAutogenerateInput";
import QuantityPickerSidebar from "../../../UIElements/Sidebars/QuantityPickerSidebar";
import { numberEditor } from "../../../../Utils/TableEditors";
import { DisplayErrors } from "../../../../Utils/ErrorHandler";

const NewProductsReturn = () => {

    const ctx = useContext(EnumsContext);
    const isMobile = useIsMobile();
    const navigate = useNavigate();
    const location = useLocation();
    const toast = useRef(null);
    const { createClientReturnAct, deletePaymentFromAct, fetchActPayments, fetchClientReturnActDetails, fetchSaleActDetails, fetchClientReturnActHistory, fetchClientReturnActDocuments, fetchSaleActs, updateClientReturnAct } = useApi();

    const [actHistory, setActHistory] = useState(null);
    const [actPayments, setActPayments] = useState(null);
    const [actProducts, setActProducts] = useState(null);
    const [docArchive, setDocArchive] = useState(null);
    const [docArchiveTotalRecords, setDocArchiveTotalRecords] = useState(0);
    const [historyTotalRecords, setHistoryTotalRecords] = useState(0);
    const [isEdit, setIsEdit] = useState(false);
    const [isFinalized, setIsFinalized] = useState(false);
    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 768);
    const [quantitySideBarVisible, setQuantitySidebarVisible] = useState(false);
    const [searchDate, setSearchDate] = useState(null);
    const [selectedAct, setSelectedAct] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [showFilterMenu, setShowFilterMenu] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [tabShowed, setTabShowed] = useState(0);
    const [totaLActSum, setTotalActSum] = useState(0);
    const [userSales, setUserSales] = useState(null);
    const [visible, setVisible] = useState(false);
    const [historyLazyState, setHistoryLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });
    const [actData, setActData] = useState({
        cagent: null,
        division: null,
        act_number: '',
        act_number_autogenerate: true,
        act_date: new Date(),
        pay_due_date: new Date(),
        status: "Драфт",
        identified_products: [],
        unidentified_products: [],
    });
    const [docArchiveLazyState, setDocArchiveLazyState] = useState({
        first: 0,
        rows: 10,
        page: 1
    });

    const enumTypes = useMemo(() => ["divisions", "pay_statuses", "clients"], []);

    useGetEnums(enumTypes);

    const getDivisionLabel = useEnumLabel(ctx.enums.divisions.data);
    const getClientLabel = useEnumLabel(ctx.enums.clients.data);
    const getPayStatusLabel = useEnumLabel(ctx.enums.pay_statuses.data);

    useEffect(() => {
        const handleResize = () => {
            setIsLargeScreen(window.innerWidth >= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (location.state !== null) {

            if (location.state.id !== undefined) {
                const getReturnActDetails = async () => {
                    const response = await fetchClientReturnActDetails(location.state.id);
                    console.log(response.data);

                    if (response.status === 200) {

                        setIsFinalized(response.data.status !== "PENDING");
                        response.data.act_date = new Date(response.data.act_date);
                        response.data.pay_due_date = new Date(response.data.pay_due_date);

                        if (response.data.identified_products.length > 0) {
                            response.data.identified_products.forEach(element => {
                                element.totalPrice = element.price;
                                element.totalPriceUAH = element.priceUAH;
                            });
                        }

                        if (response.data.unidentified_products.length > 0) {
                            response.data.totalPrice = response.data.price * response.data.quantity;
                            response.data.unidentified_products.forEach(element => {
                                element.totalPrice = element.price * element.quantity;
                                element.totalPriceUAH = element.priceUAH * element.quantity;
                            });
                        }

                        setActData(response.data);
                    }

                    setIsEdit(true);
                };

                getReturnActDetails();
            }
            else if (location.state.saleId !== undefined) {
                console.log(location.state);
                const getSaleActDetails = async () => {
                    const response = await fetchSaleActDetails(location.state.saleId);

                    if (response.status === 200) {
                        let returnAct = {
                            cagent: response.data.cagent !== null ? response.data.cagent : null,
                            division: response.data.division,
                            act_number: '',
                            act_number_autogenerate: true,
                            act_date: new Date(),
                            pay_due_date: new Date(),
                            status: "Драфт",
                            identified_products: [],
                            unidentified_products: [],
                        }


                        if (response.data.identified_products.length > 0) {

                            response.data.identified_products.forEach(product => {
                                product.totalPrice = product.price;
                                product.totalPriceUAH = product.priceUAH;
                                product.return_sale_act_id = response.data.id;
                            });
                            returnAct.identified_products = response.data.identified_products;
                        }

                        if (response.data.unidentified_products.length > 0) {

                            response.data.totalPrice = response.data.price * response.data.quantity;
                            response.data.unidentified_products.forEach(product => {
                                product.return_sale_act_id = response.data.id;
                                product.totalPrice = product.price * product.quantity;
                                product.totalPriceUAH = product.priceUAH * product.quantity;
                            });
                            returnAct.unidentified_products = response.data.unidentified_products;
                        }

                        setActData(returnAct);
                    }
                }

                getSaleActDetails();
            }
        }
    }, [fetchClientReturnActDetails, fetchSaleActDetails, location.state]);

    const formik = useFormik({
        initialValues: actData,
        enableReinitialize: true,
        validate: values => {
            const errors = {};

            if (values.division === null || values.division === undefined) {
                errors.division = "Виберіть точку продажу";
            }

            if (!values.act_number_autogenerate) {
                if (values.act_number === null || values.act_number === "") {
                    errors.act_number = "Введіть номер акту";
                }
            }

            if (values.identified_products.length === 0 && values.unidentified_products.length === 0) {
                errors.products = "Додайте будь ласка товари"
            }
            return errors;
        },
        onSubmit: async (values) => {

            setSubmitLoading(true);

            const payload = {
                ...values,
                act_date: formatShortDate(values.act_date),
                pay_due_date: formatShortDate(values.pay_due_date),
                act_number: values.act_number === "" ? null : values.act_number,
                cagent: values.cagent ??= null
            }

            const response = isEdit ? await updateClientReturnAct(values.id, payload) : await createClientReturnAct(payload);

            setSubmitLoading(false);

            console.log(response.status);

            const successStatus = isEdit ? 200 : 201;

            if (response.status === successStatus) {
                const toastMessage = { severity: "success", summary: "Успіх " + (isEdit ? "редагування" : "cтворення"), detail: "Акт успішно " + (isEdit ? "відредаговано" : "створено"), life: 3000 }
                navigate("/productsreturn", { state: { toast: toastMessage } });
            }
            else{
                console.log(response.error);
                DisplayErrors(response.error, toast);
            }
        }
    });

    useEffect(() => {
        let calcAmount = 0;

        if (formik.values?.unidentified_products?.length > 0) {
            calcAmount += formik.values.unidentified_products.reduce((sum, prod) => sum + convertSumWithLatestCurrencyRate(prod.currency, (prod.quantity ?? 1) * prod.price), 0);
        }

        if (formik.values?.identified_products?.length > 0) {
            calcAmount += formik.values.identified_products.reduce((sum, prod) => sum + convertSumWithLatestCurrencyRate(prod.currency, prod.price), 0);
        }

        setTotalActSum(calcAmount);

    }, [formik.values.identified_products, formik.values.unidentified_products])

    const GetUserSalesActs = async () => {

        const state = {
            rows: 200,
            page: 1,
            sortField: "created_at",
            sortOrder: 1,
            filters: {
                division: {value: formik.values.division},
                status: { value: "FINALIZED" }
            }
        };

        if (searchDate !== null) {
            state.filters.date = { value: searchDate }
        }
        if (formik.values.cagent !== null) {
            state.filters.cagent = { value: formik.values.cagent }
        }

        setUserSales(null);
        setSelectedAct(null);
        const response = await fetchSaleActs(state);

        if (response.status === 200) {
            if (response.data.results.length > 0) {
                console.log(response.data.results);
                const saleActs = response.data.results.map(act => ({
                    label: `${act.act_number} (${getClientLabel(act.cagent) || "Без клієнта"})`,
                    value: act.id,
                }));

                setUserSales(saleActs);
            }
            else {
                toast.current.show({ severity: "info", summary: "Пошук актів", detail: `Не знайдено актів продажу у вказаний період`, life: 3000 });
            }
        }
    }

    const getActDetails = async (id) => {
        const response = await fetchSaleActDetails(id);

        if (response.status === 200) {
            let actProducts = [];
            console.log(response.data);

            if (response.data.identified_products !== null && response.data.identified_products.length > 0) {
                actProducts = response.data.identified_products;
            }
            if (response.data.unidentified_products !== null && response.data.unidentified_products.length > 0) {
                actProducts = [...actProducts, ...response.data.unidentified_products];
            }
            console.log(actProducts);
            setActProducts(actProducts);
        }

        setSelectedAct(id);
    }

    const AddProductToHandler = (rowData) => {
        if (rowData.identifier === undefined && rowData.quantity > 1) {
            setSelectedProduct(rowData);
            setQuantitySidebarVisible(true);
        }
        else {
            AddProductToAct(rowData);
        }
    }

    const AddingWithQuantity = (amount) => {
        const changedProduct = selectedProduct;
        changedProduct.quantity = amount;
        AddProductToAct(changedProduct);
        setQuantitySidebarVisible(false);
    }

    const AddProductToAct = (rowData) => {

        rowData.return_sale_act_id = selectedAct;

        if (rowData.identifier !== undefined && rowData.identifier !== null) {
            if (!formik.values.identified_products.some(obj => obj.identifier === rowData.identifier)) {
                rowData.totalPrice = rowData.price;
                rowData.totalPriceUAH = rowData.priceUAH;
                let newobject = formik.values.identified_products;
                newobject = [...newobject, rowData];
                formik.setFieldValue("identified_products", newobject);
            }
            else {
                toast.current.show({ severity: "info", summary: "Помилка додавання", detail: `Товар ${rowData.product} (ID:${rowData.identifier}) уже додано`, life: 3000 });
            }
        }
        else {
            rowData.totalPrice = rowData.price * rowData.quantity;
            rowData.totalPriceUAH = rowData.priceUAH * rowData.quantity;
            let newobject = formik.values.unidentified_products;
            newobject = [...newobject, rowData];
            formik.setFieldValue("unidentified_products", newobject);
        }
    }

    const handleCellEditComplete = (e, arrayName) => {
        const rowIndex = e.index ?? e.rowIndex;

        const updated = [...formik.values[arrayName]];
        updated[rowIndex] = {
            ...updated[rowIndex],
            [e.field]: e.newValue
        };

        formik.setFieldValue(arrayName, updated);
    };

    const DeleteFieldHandler = (rowData) => {

        let fields = [];
        let name = '';

        if (rowData.identifier !== null && rowData.identifier !== undefined) {
            fields = formik.values.identified_products;
            name = "identified_products";
        }
        else {
            fields = formik.values.unidentified_products;
            name = "unidentified_products";
        }

        const updatedFields = [...fields];

        const index = fields.findIndex(function (field) {
            return field.fe_id === rowData.fe_id;
        });

        // setTotalActSum(totaLActSum - +fields[index].totalPriceUAH);

        updatedFields.splice(index, 1);
        formik.setFieldValue(name, updatedFields);
    };

    const UnbindPayment = async (paymentId) => {

        const request = {
            act_id: location.state.id,
            payment_id: paymentId
        }

        const response = await deletePaymentFromAct(request);

        console.log(response);
        if (response.status === 204) {

            const index = actPayments.findIndex(payment => payment.id === paymentId);
            if (index !== -1) {
                // Create a new array with the element removed
                const newPayments = [...actPayments.slice(0, index), ...actPayments.slice(index + 1)];
                console.log(newPayments);

                // Set the updated state
                setActPayments(newPayments);
            }

            toast.current.show({ severity: "success", summary: "Платіж відвязано", detail: "Платіж відвязано від акту", life: 3000 });

        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка відвязки платежу", detail: "Платіж не відвязано від акту. Код помилки: " + response.status, life: 3000 });
        }
    }

    const getActPayments = async (id) => {

        const response = await fetchActPayments(location.state.id);

        if (response.status === 200) {
            setActPayments(response.data.results);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання платежів", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const getActHistory = async (id, state) => {

        const response = await fetchClientReturnActHistory(id, state);

        console.log(response);

        if (response.status === 200) {
            setActHistory(response.data.results);
            setHistoryTotalRecords(response.data.count);
        }
        else {
            toast.current.show({ severity: "error", summary: "Помилка отримання історії", detail: "Помилка сервера " + response.status, life: 3000 });
        }
    }

    const getDocumentsArchive = async (id, lazyState) => {

        const response = await fetchClientReturnActDocuments(id, lazyState);

        if (response.status === 200) {
            setDocArchive(response.data.results);
            setDocArchiveTotalRecords(response.data.count);
        }
    }

    const onHistoryPage = (event) => {
        event.page = event.page + 1;
        getActHistory(location.state.id, event);

        setHistoryLazyState(event);
    }

    const onDocArchivePage = (event) => {
        event.page = event.page + 1;
        getDocumentsArchive(location.state.id, event);

        setDocArchiveLazyState(event);
    }

    const items = [
        {
            label: 'Деталі акту',
            icon: 'pi pi-book',
            command: () => {
                setTabShowed(0);
            },
        },
        ...(isFinalized
            ? [
                {
                    label: 'Платежі',
                    icon: 'pi pi-money-bill',
                    command: () => {
                        setTabShowed(1);
                        getActPayments(location.state.id);
                    },
                },
            ]
            : []),
        ...(isEdit
            ? [
                {
                    label: 'Історія',
                    icon: 'pi pi-history',
                    command: () => {
                        setTabShowed(2);
                        getActHistory(location.state.id, historyLazyState);
                    },
                },
                {
                    label: 'Документи',
                    icon: 'pi pi-save',
                    command: () => {
                        setTabShowed(3);
                        getDocumentsArchive(location.state.id, historyLazyState);
                    },
                }
            ]
            : []),
    ];

    const toolbarLeftData = () => {

        let name = "Новий акт повернення товарів";
        if (isEdit) {
            if (isFinalized) {
                name = "$Перегляд акту повернення товарів #" + location.state?.id;
            }

            name = "Редагування акту повернення товарів #" + location.state?.id;
        }

        return !isMobile ? <h3>{name}</h3> : null;
    }

    const contentToolbarRightTemplate = () => {
        return (<>
            <div className="flex flex-wrap gap-2">
                <Button label="+Додати товар" severity="success" className={commonStyle.addButton} onClick={() => setVisible(true)} type="button" />
            </div>
        </>);
    }

    const setTableHeader = (tablename) => {
        return (
            <div className="flex flex-wrap align-items-center justify-content-between gap-2">
                <span className={!isMobile ? "text-xl text-900 font-bold" : "font-bold"}>{tablename}</span>
            </div>
        );
    }

    const TableFooter = (data) => {

        const totalValue = data.reduce((accumulator, element) => accumulator + element.priceUAH * (element.quantity ?? 1), 0);
        console.log(data);

        return (
            <div className={commonStyle.footerContainer}>
                <label>Cума: {formatCurrency(totalValue, "UAH")}</label>
            </div>)
    }

    const tableActionBodyTemplate = (rowData) => {
        return (<div className="flex flex-wrap gap-2">
            {!isFinalized && <Button
                icon="pi pi-trash"
                type="button"
                className={`p-button-rounded p-button-danger ${commonStyle.deleteButton}`}
                tooltip="Видалити з таблиці"
                tooltipOptions={{ position: "left" }}
                onClick={() => DeleteFieldHandler(rowData)}
            />}
        </div>
        );
    };

    const nameTemplate = (rowData) => {
        return `(x${rowData.quantity === undefined ? 1 : rowData.quantity}) ${rowData.product}`;
    }

    const sideBarBodyTemplate = (rowData) => {

        let isReturned = false;
        if (rowData.identifier !== undefined) {
            if (!rowData.can_be_returned) {
                isReturned = true
            }
        }
        else {
            if (rowData.can_be_returned_amount === 0) {
                isReturned = true
            }
        }

        return (<div className="flex flex-wrap gap-2">
            {!isFinalized && <Button
                icon="pi pi-plus"
                disabled={isReturned}
                type="button"
                className={`p-button-rounded p-button-success ${isReturned ? commonStyle.closeButton : commonStyle.addButton}`}
                tooltip={isReturned ? "Товар повернуто" : "Додати"}
                tooltipOptions={{ showOnDisabled: true, position: "left" }}
                onClick={() => AddProductToHandler(rowData)}
            />}
        </div>
        );
    };

    const confirmLeave = (event) => {

        if (formik.values !== actData) {

            confirmDialog({
                group: 'headless',
                header: 'Незбережені зміни',
                message: 'У вас є незбережені зміни. Ви впевнені, що хочете залишити цю сторінку?',
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: "Так",
                rejectLabel: "Hi",
                defaultFocus: 'accept',
                accept: () => { navigate("/productsreturn", { state: { pageState: location.state?.pageState } }) }
            });

        }
        else {
            navigate("/productsreturn", { state: { pageState: location.state?.pageState } });
        }
    }

    const mobileProductBody = (rowData) => {
        return (
            <div className="flex justify-content-between flex-wrap">
                <div className="grid w-8">
                    <div className="col-12">
                        <div className="flex-column">
                            <div className="font-bold">x{rowData.quantity ?? "1"} {rowData.product}</div>
                            <div>{rowData.note}</div>
                            {rowData.identifier && <div>ID: {rowData.identifier}</div>}
                            <div>Ціна за од: {formatCurrency(rowData.price, rowData.currency)}</div>
                            <div>Ціна за од, грн: {formatCurrency(rowData.priceUAH, "UAH")}</div>
                        </div>
                    </div>
                </div>
                <div className="flex justify-content-center align-items-center">
                    {tableActionBodyTemplate(rowData)}
                </div>
            </div>
        )
    }

    return (<form onSubmit={formik.handleSubmit}>
        <Toast ref={toast} />
        <CommonToolbar isMobile={isMobile} isFinalized={isFinalized} loading={submitLoading} onRetunButtonClick={(event) => confirmLeave(event)} leftContent={toolbarLeftData()} />
        <ConfirmDialog group="headless" />
        <TabMenu model={items} />
        {tabShowed === 0 && <div className="grid">
            {(isMobile && isFinalized) ? (<div className="col-12 ml-3 text-lg">
                <div className="mt-3"><span className="font-bold">Aкт: </span>{"№" + formik.values.act_number}</div>
                <div><span className="font-bold">Контрагент: </span> {getClientLabel(formik.values.cagent)}</div>
                <div><span className="font-bold">Точка продажу: </span>{getDivisionLabel(formik.values.division)}</div>
                <div><span className="font-bold">Дата акту: </span>{formatShortDate(formik.values.act_date)}</div>
                <div><span className="font-bold">Очікувана дата оплати: </span>{formatShortDate(formik.values.pay_due_date)}</div>
                <div><span className="font-bold">Статус: </span>{formik.values.status === "FINALIZED" ? "Фіналізований" : "Драфт"}</div>
                <div><span className="font-bold">Статус оплати: </span>{getPayStatusLabel(formik.values.pay_status)}</div>
            </div>) :
                (<div className={`${commonStyle.leftMenu} col-5 md:col-4 lg:col-3`}>
                    <DropdownInput
                        formik={formik}
                        paramName={"division"}
                        context={ctx.enums.divisions.data}
                        onChange={(val) => formik.setFieldValue("division", val)}
                        label={"Точка продажу"}
                        isDisabled={isFinalized}
                        isMobile={isMobile}
                        mandatory />
                    <DropdownInput
                        formik={formik}
                        paramName={"cagent"}
                        context={ctx.enums.clients.data}
                        onChange={(val) => formik.setFieldValue("cagent", val)}
                        label={"Клієнт"}
                        isDisabled={isFinalized}
                        isMobile={isMobile} />
                    <CalendarInput formik={formik} paramName={"act_date"} label={"Дата акту"} isDisabled={isFinalized} isMobile={isMobile} />
                    <CalendarInput formik={formik} paramName={"pay_due_date"} label={"Очікувана дата оплати"} isDisabled={isFinalized} isMobile={isMobile} />
                    <ActNumberWithAutogenerateInput formik={formik} showAutogenerate={!isEdit} isDisabled={isFinalized} />
                    <div className={commonStyle.formInput}>
                        <div className="p-inputgroup flex-column">
                            <FloatLabel>
                                <InputText
                                    value={formik.values.status === "FINALIZED" ? "Фіналізований" : "Драфт"}
                                    disabled
                                    className="w-full" />
                                <label>Статус</label>
                            </FloatLabel>
                        </div>
                    </div>
                </div>)}
            <div className={`${isMobile ? "col-12" : "col-7 md:col-8 lg:col-9"}`}>
                {!isFinalized && <Toolbar className="mb-4" end={contentToolbarRightTemplate}></Toolbar>}
                {(!isMobile && formik.values.identified_products.length > 0) && <DataTable value={formik.values.identified_products}
                    header={setTableHeader("Товари індивідуального обліку")} footer={() => TableFooter(formik.values.identified_products)} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="product" header="Продукт" style={{ width: '22%' }} />
                    <Column field="identifier" header="Ідентифікатор" style={{ width: '15%' }} />
                    <Column field="price" header="Ціна за одиницю" body={(rowdata) => formatCurrency(rowdata.price, rowdata.currency)} style={{ width: '15%' }} />
                    <Column field="priceUAH" header="Ціна за одиницю, грн" body={(rowdata) => formatCurrency(rowdata.priceUAH, "UAH")} style={{ width: '15%' }} />
                    <Column field="totalPrice" header="Загальна ціна" body={(rowData) => formatCurrency(rowData.totalPrice, rowData.currency)} style={{ width: '15%' }} />
                    <Column field="totalPriceUAH" header="Загальна ціна, грн" body={(rowData) => formatCurrency(rowData.totalPriceUAH, "UAH")} style={{ width: '15%' }} />
                    <Column field="action" body={tableActionBodyTemplate} style={{ width: '12%' }} />
                </DataTable>}
                {(isMobile && formik.values.identified_products.length > 0) && <DataTable value={formik.values.identified_products} header={setTableHeader("Товари індивідуального обліку")}
                    footer={() => TableFooter(formik.values.identified_products)}>
                    <Column field="product_name" headerStyle={{ display: 'none' }} body={(rowData) => mobileProductBody(rowData)} />
                </DataTable>}
                {(!isMobile && formik.values.unidentified_products.length > 0) && <DataTable value={formik.values.unidentified_products}
                    header={setTableHeader("Товари поштучного обліку")} editMode="cell" footer={() => TableFooter(formik.values.unidentified_products)} tableStyle={{ minWidth: '50rem' }}>
                    <Column field="product" header="Продукт" style={{ width: '22%' }}></Column>
                    <Column field="quantity" header="Кількість" 
                        editor={(options) => numberEditor(options, options.rowData.measurement_unit === "PIECES" ? 0 : 2)} onCellEditComplete={(e) => handleCellEditComplete(e, "unidentified_products")}
                        body={(rowData) => formatQuantityWithMeasurement(rowData.quantity, rowData.measurement_units)} style={{ width: '15%' }}></Column>
                    <Column field="price" header="Ціна за одиницю" body={(rowdata) => formatCurrency(rowdata.price, rowdata.currency)} style={{ width: '15%' }} />
                    <Column field="priceUAH" header="Ціна за одиницю, грн" body={(rowdata) => formatCurrency(rowdata.priceUAH, "UAH")} style={{ width: '15%' }} />
                    <Column field="totalPrice" header="Загальна ціна" body={(rowData) => formatCurrency(rowData.price * rowData.quantity, rowData.currency)} style={{ width: '15%' }} />
                    <Column field="totalPriceUAH" header="Загальна ціна, грн" body={(rowData) => formatCurrency(rowData.priceUAH * rowData.quantity, "UAH")} style={{ width: '15%' }} />
                    <Column field="action" body={tableActionBodyTemplate} style={{ width: '12%' }} />
                </DataTable>}
                {(isMobile && formik.values.unidentified_products.length > 0) && <DataTable value={formik.values.unidentified_products} header={setTableHeader("Товари поштучного обліку")}
                    footer={() => TableFooter(formik.values.unidentified_products)}>
                    <Column field="product_name" headerStyle={{ display: 'none' }} body={(rowData) => mobileProductBody(rowData)} />
                </DataTable>}
                {(formik.values.unidentified_products.length > 0 || formik.values.identified_products.length > 0) && <><div className={commonStyle.footerContainer}>
                    <h3>Загальна сума акту: {formatCurrency(totaLActSum, "UAH")}</h3>
                </div>
                </>}
            </div>
        </div>}
        {tabShowed === 1 && isFinalized && <ActPayments isMobile={isMobile} payments={actPayments} onUnbindClick={UnbindPayment} />}
        {tabShowed === 2 && <HistoryElement data={actHistory} lazyState={historyLazyState} totalRecords={historyTotalRecords} onHistoryPage={onHistoryPage} isAct={true} />}
        {tabShowed === 3 && <DocumentArchiveTable documents={docArchive} lazyState={docArchiveLazyState} onPage={onDocArchivePage} totalRecords={docArchiveTotalRecords} toast={toast} />}
        <Sidebar visible={visible} position="right" className={`${commonStyle.shortSideBar} ${quantitySideBarVisible && isLargeScreen ? commonStyle.moveLeft : ''}`} onHide={() => setVisible(false)}>
            {!showFilterMenu && <Button icon="pi pi-arrow-down" label="Показати фільтри" severity="secondary" className={`mr-2 ${commonStyle.sideBarButton}`} outlined onClick={() => setShowFilterMenu(true)} />}
            {showFilterMenu && <Card>
                <h3>Фільтри пошуку актів</h3>
                <DropdownInput
                    formik={formik}
                    paramName="division"
                    context={ctx.enums.divisions.data}
                    onChange={(val) => formik.setFieldValue("division", val)}
                    label="Точка продажу"
                    isDisabled={isFinalized}
                    isMobile={isMobile}
                    customStyle="w-full"
                    mandatory
                />
                <div className={commonStyle.sideBarInput}>
                    <div className="p-inputgroup flex-column">
                        <FloatLabel>
                            <Calendar
                                value={searchDate}
                                onChange={(e) => setSearchDate(e.value)}
                                dateFormat="dd.mm.yy"
                                selectionMode="range"
                                readOnlyInput
                                hideOnRangeSelection
                                className="w-full" />
                            <label>Дата акту продажу</label>
                        </FloatLabel>
                    </div>
                </div>
                <DropdownInput
                    formik={formik}
                    paramName="cagent"
                    context={ctx.enums.clients.data}
                    onChange={(val) => formik.setFieldValue("cagent", val)}
                    label="Клієнт"
                    isDisabled={isFinalized}
                    isMobile={isMobile}
                    customStyle="w-full"
                />
                <div className="flex flex-row mt-4">
                <Button icon="pi pi-arrow-up" label="Приховати фільтри" severity="secondary" className="mr-2" outlined onClick={() => setShowFilterMenu(false)} />
                <Button label="Застосувати" severity={formik.values.division ? "success" : "disabled"} outlined disabled={!formik.values.division} onClick={() => GetUserSalesActs()} />
                </div>
            </Card>}
            {userSales !== null && <div className={commonStyle.sideBarInput}>
                <div className="p-inputgroup flex-column">
                    <FloatLabel>
                        <Dropdown
                            value={selectedAct}
                            onChange={(e) => getActDetails(e.value)}
                            options={userSales}
                            showClear
                            className="w-full"
                        />
                        <label>Акт</label>
                    </FloatLabel>
                    {formik.errors.cagent && formik.touched.cagent && (<small className={commonStyle.errorSmall}>{formik.errors.cagent}</small>)}
                </div>
            </div>}
            {(selectedAct !== null && actProducts !== null) && <div>
                <DataTable value={actProducts}>
                    <Column field="product" header="Продукт" body={nameTemplate} />
                    <Column field="identifier" header="ID" />
                    <Column field="action" align="right" body={sideBarBodyTemplate} />
                </DataTable>
            </div>}
        </Sidebar>
        <QuantityPickerSidebar visible={quantitySideBarVisible} onHide={() => setQuantitySidebarVisible(false)} selectedRemaining={selectedProduct} onSelect={(amount) => AddingWithQuantity(amount)} />
    </form>);
}

export default NewProductsReturn;